import Markdown from "react-markdown";
import { ENV } from "../../../Utils";

export const GptMessage = ({ text, imageAvatar }) => {
  const imageUrl = imageAvatar
    ? `${imageAvatar}`
    : `${ENV.BASE_PATH}/default-avatar.png`;

  //console.log("GptMessage -> imageUrl", `${ENV.BASE_PATH}/${imageAvatar}`);
  return (
    <div className="col-start-1 col-end-9 p-3 rounded-lg flex gpt-message">
      <img src={imageUrl} alt="Avatar" className="gpt-avatar" />
      <div className="gpt-bubble">
        <Markdown>{text}</Markdown>
      </div>
    </div>
  );
};
